import {
  CheckIcon,
  CircleAlertIcon,
  LoaderCircleIcon,
  PauseIcon,
  MinusIcon,
  XIcon,
} from 'lucide-react';
import type { ChatCopy } from '@/lib/chat-i18n';
import type { ToolOutcome } from './tool-presentation';

const icons = {
  complete: CheckIcon,
  running: LoaderCircleIcon,
  error: CircleAlertIcon,
  cancelled: XIcon,
  approval: PauseIcon,
  incomplete: MinusIcon,
};
export function ToolStateIcon({ outcome }: { outcome: ToolOutcome }) {
  const Icon = icons[outcome];
  return <Icon aria-hidden className="pc-tool-state-icon" />;
}

export function toolStatusLabel(outcome: ToolOutcome, copy: ChatCopy) {
  return {
    complete: copy.toolComplete,
    running: copy.toolRunning,
    error: copy.toolError,
    cancelled: copy.toolCancelled,
    approval: copy.toolNeedsApproval,
    incomplete: copy.toolIncomplete,
  }[outcome];
}
